/**
 * NASDAQ Quantum — wiring del indicador.
 *
 * Universal (WP §1): corre sobre las velas del símbolo/TF que el usuario
 * tenga activo en el chart, sin fuente de datos nueva. Formato de señales
 * PRQ (molde `patron_ruptura_quantum`, Standard A.3): badge + panel +
 * renderer canvas, vía `createChartDrawingApi`.
 */

import BadgeComponent from './Badge.jsx'
import PanelComponent from './Panel.jsx'
import {
  SAFE_DEFAULTS,
  resolveConfig,
  symbolMatches,
} from './constants.js'
import { runAdapter } from './adapter.js'
import { renderNasdaqQuantum } from './renderer.js'
import { getChartContext } from './context.js'

export const defaultConfig = SAFE_DEFAULTS

export { resolveConfig }

function gatedResult() {
  return { ranges: [], signals: [], activeSignal: null, lastSignal: null, dashboard: null, emaSeries: [], gated: true }
}

/** Sanea velas de entrada: OHLC numéricos y time presente (molde PRQ). */
function sanitizeCandles(candles) {
  if (!Array.isArray(candles)) return null
  const out = []
  for (const c of candles) {
    if (c == null || typeof c !== 'object') continue
    const open = Number(c.open)
    const high = Number(c.high)
    const low = Number(c.low)
    const close = Number(c.close)
    if (!Number.isFinite(open) || !Number.isFinite(high) || !Number.isFinite(low) || !Number.isFinite(close)) continue
    if (c.time == null || c.time === '') continue
    out.push({ time: c.time, open, high, low, close, volume: Number.isFinite(Number(c.volume)) ? Number(c.volume) : 0 })
  }
  return out
}

export function detect(candles, rawConfig) {
  try {
    const cfg = resolveConfig(rawConfig)
    if (cfg.enabled === false) return gatedResult()

    const ctx = getChartContext() || {}
    if (!symbolMatches(cfg.assets, ctx.symbol)) return gatedResult()

    const clean = sanitizeCandles(candles)
    if (!clean) return gatedResult()

    // Contrato F.2 del Standard: el motor asume velas CERRADAS -- se
    // descarta la última (en formación) antes de evaluar cualquier
    // condición, igual que el resto de motores de presentación en cliente.
    const closedCandles = clean.length > 1 ? clean.slice(0, -1) : []
    if (closedCandles.length === 0) return gatedResult()

    const out = runAdapter(closedCandles, cfg, ctx)
    return { ...out, showLastSignals: cfg.showLastSignals }
  } catch {
    return gatedResult()
  }
}

export function render(chart, candleSeries, result, config, api) {
  renderNasdaqQuantum(chart, candleSeries, result, config, api)
}

export default {
  id: 'nasdaq_quantum',
  name: 'NASDAQ Quantum',
  version: '0.1.0',
  defaultConfig,
  detect,
  render,
  BadgeComponent,
  PanelComponent,
  // Mismo patrón anti-flicker que PRQ (Standard, molde A.3): las primitivas
  // (líneas/zonas nativas de LWC + labels) panean solas; reconstruirlas en
  // cada frame de pan las hace parpadear.
  renderOnPan: false,
}
